'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _storefront = require('./remote/storefront');

var Storefront = {
    fetchLotsBySellerId: _storefront.storefrontRemote.fetchLotsBySellerId
};

exports.default = Storefront;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/storefront.js
// module id = K6kQ
// module chunks = 60